import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import TrainingLayout from "./components/TrainingLayout";
import TrainerLayout from "./components/TrainerLayout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import SubmissionsPage from "./pages/SubmissionsPage";
import SubmissionDetailPage from "./pages/SubmissionDetailPage";
import WebhookConfigPage from "./pages/WebhookConfigPage";
import FieldMappingPage from "./pages/FieldMappingPage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import FormDashboardPage from "./pages/FormDashboardPage";
import CareerAdvisorDashboard from "./pages/CareerAdvisorDashboard";
import ManagementAuditDashboard from "./pages/ManagementAuditDashboard";
import TargetPlanDashboard from "./pages/TargetPlanDashboard";
import TrainingDashboardPage from "./pages/training/TrainingDashboardPage";
import MastersPage from "./pages/training/MastersPage";
import BatchManagementPage from "./pages/training/BatchManagementPage";
import StudentsPage from "./pages/training/StudentsPage";
import SlotFinderPage from "./pages/training/SlotFinderPage";
import ReportsPage from "./pages/training/ReportsPage";
import FeatureRequestsPage from "./pages/training/FeatureRequestsPage";
import AnomaliesPage from "./pages/training/AnomaliesPage";
import SyncSettingsPage from "./pages/training/SyncSettingsPage";
import TicketsPage from "./pages/training/TicketsPage";
import TicketPerformancePrototype from "./pages/training/TicketPerformancePrototype";
import AskBaskyFullPage from "./pages/training/AskBaskyFullPage";
import TrainerScorecardPage from "./pages/training/TrainerScorecardPage";
import NewTrainerScorecardPage from "./pages/training/NewTrainerScorecardPage";
import WeeklyPlanPage from "./pages/WeeklyPlanPage";
import TrainerOverviewPage from "./pages/training/TrainerOverviewPage";
import TrainerOverviewV2Page from "./pages/training/TrainerOverviewV2Page";
import TrainerLoginPage from "./pages/trainer/TrainerLoginPage";
import TrainerDashboardPage from "./pages/trainer/TrainerDashboardPage";
import TrainerBatchDetailPage from "./pages/trainer/TrainerBatchDetailPage";
import TrainerReportPage from "./pages/trainer/TrainerReportPage";
import TrainerDailyAttendancePage, { AdminDailyAttendancePage } from "./pages/trainer/TrainerDailyAttendancePage";
import DprReportPage from "./pages/trainer/DprReportPage";
import TrainerOverduePage from "./pages/trainer/TrainerOverduePage";
import TrainerCreditNotesPage from "./pages/trainer/TrainerCreditNotesPage";
import CnReviewPage from "./pages/training/cn-review/CnReviewPage";
import TrainerTargetPage from "./pages/trainer-target/TrainerTargetPage";
import VoucherPage from "./pages/vouchers/VoucherPage";
import MenuSettingsPage from "./pages/training/MenuSettingsPage";
import DemoQueuePage from "./pages/training/demo/DemoQueuePage";
import NewDemoPage from "./pages/training/demo/NewDemoPage";
import DemoReportPage from "./pages/training/demo/DemoReportPage";
import DemoSetupPage from "./pages/training/demo/DemoSetupPage";
import DemoConversionsPage from "./pages/training/demo/DemoConversionsPage";
import DemoAnalyticsPage from "./pages/training/demo/DemoAnalyticsPage";
import DemoIncentivePage from "./pages/training/demo/DemoIncentivePage";
import DemoDetailPage from "./pages/training/demo/DemoDetailPage";
import AttendanceReportPage from "./pages/training/AttendanceReportPage";
import TrainerPerformancePage from "./pages/training/TrainerPerformancePage";
import AdminTrainerDashboardPage from "./pages/training/TrainerDashboardPage";
import PdpMockStatusPage from "./pages/training/PdpMockStatusPage";
import TrainerLabPage from "./pages/training/TrainerLabPage";
import AuditFormPage from "./pages/training/audit/AuditFormPage";
import AuditReportPage from "./pages/training/audit/AuditReportPage";
import ExecutiveReportPage from "./pages/training/audit/ExecutiveReportPage";
import ManagerAssignmentsPage from "./pages/training/audit/ManagerAssignmentsPage";
import DprComplianceReport from "./pages/training/DprComplianceReport";import OverdueReportPage from "./pages/training/OverdueReportPage";
import AuditBookmarksPage from "./pages/training/AuditBookmarksPage";
import CourseSyllabusPage from "./pages/training/CourseSyllabusPage";
import DocumentLibraryPage from "./pages/training/DocumentLibraryPage";
import CreditNotesPage from "./pages/training/CreditNotesPage";
import ReconciliationReportPage from "./pages/training/ReconciliationReportPage";
import IncentivePayoutDashboard from "./pages/IncentivePayoutDashboard";
import ZohoReportsHub from "./pages/ZohoReportsHub";
import ZohoIntegrationMap from "./pages/ZohoIntegrationMap";
import CustomViewsPrototype from "./pages/CustomViewsPrototype";
import MomListPage from "./pages/training/mom/MomListPage";
import MomDetailPage from "./pages/training/mom/MomDetailPage";
import MomNewPage from "./pages/training/mom/MomNewPage";
import MomReportPage from "./pages/training/mom/MomReportPage";
import ReportsLandingPage from "./pages/reports/ReportsLandingPage";
import IncentiveReportPage from "./pages/reports/IncentiveReportPage";
import ActivityTimelinePage from "./pages/governance/ActivityTimelinePage";
import WhatsNewPage from "./pages/whats-new/WhatsNewPage";
import WhatsNewModal from "./components/whats-new/WhatsNewModal";
import SalesUploadsPage from "./pages/sales-uploads/SalesUploadsPage";
import PublicUploadPortal from "./pages/sales-uploads/PublicUploadPortal";
import PlacementPage from "./pages/placement/PlacementPage";
import VenuePortalLayout from "./pages/venue/VenuePortalLayout";
import VenueRequirementForm from "./pages/venue/VenueRequirementForm";
import VenueCalendarPage from "./pages/venue/VenueCalendarPage";
import VenueLabOccupancyPage from "./pages/venue/VenueLabOccupancyPage";
import VenueRequirementsListPage from "./pages/venue/VenueRequirementsListPage";
import VenueRequirementDetailPage from "./pages/venue/VenueRequirementDetailPage";
import BooksAnalyticsPage from "./pages/books/BooksAnalyticsPage";
import RevenueReportPage from "./pages/books/RevenueReportPage";
import BooksCreditNotesPage from "./pages/books/CreditNotesPage";
import SalesConversionPage from "./pages/books/SalesConversionPage";
import SlipTrackerAuditPage from "./pages/books/SlipTrackerAuditPage";
import CashRegisterPage from "./pages/CashRegisterPage";
import CourseQaPage from "./pages/courseqa/CourseQaPage";
import CourseQaAllPage from "./pages/courseqa/CourseQaAllPage";
import CourseQaManagementPage from "./pages/courseqa/CourseQaManagementPage";
import CourseQaDefectsPage from "./pages/courseqa/CourseQaDefectsPage";
import CourseQaRulesPage from "./pages/courseqa/CourseQaRulesPage";
import InsideSalesAuditPage from "./pages/inside-sales/InsideSalesAuditPage";
import HotTransferPage from "./pages/hot-transfer/HotTransferPage";
import CallbackTrackerPage from "./pages/callback-tracker/CallbackTrackerPage";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-slate-50"><div className="text-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-400 mx-auto"></div><p className="font-data text-sm text-muted-foreground mt-3">Authenticating...</p></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  // Trainer users should never access admin routes
  if (user.role === 'trainer') return <Navigate to="/trainer/dashboard" replace />;
  if (roles && !roles.includes(user.role)) {
    if (user.role === 'restricted_user') return <Navigate to="/training/dashboard" replace />;
    if (user.role === 'training_manager') return <Navigate to="/training/trainer-audit/form" replace />;
    if (user.role === 'counsellor') return <Navigate to="/training/trainer-demo" replace />;
    if (user.role === 'course_qa') return <Navigate to="/course-qa" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

function TrainerProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-slate-50"><div className="text-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-400 mx-auto"></div><p className="font-data text-sm text-muted-foreground mt-3">Authenticating...</p></div></div>;
  if (!user) return <Navigate to="/trainer/login" replace />;
  if (user.role !== 'trainer') return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="font-data text-sm text-muted-foreground">Loading...</div></div>;

  // Default redirect based on role
  const defaultPath = user?.role === 'trainer' ? '/trainer/dashboard' : user?.role === 'restricted_user' ? '/training/dashboard' : user?.role === 'training_manager' ? '/training/trainer-audit/form' : user?.role === 'counsellor' ? '/training/trainer-demo' : user?.role === 'course_qa' ? '/course-qa' : '/dashboard';

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={defaultPath} replace /> : <LoginPage />} />

      {/* Public upload portal — auth handled inside the component via username/password on the link */}
      <Route path="/u/:linkId" element={<PublicUploadPortal />} />

      {/* Public Venue Requirement Portal — shared password (Venue@12), no login required */}
      <Route path="/venue" element={<VenuePortalLayout />}>
        <Route index element={<Navigate to="/venue/form" replace />} />
        <Route path="form" element={<VenueRequirementForm />} />
        <Route path="calendar" element={<VenueCalendarPage />} />
        <Route path="labs" element={<VenueLabOccupancyPage />} />
        <Route path="list" element={<VenueRequirementsListPage />} />
        <Route path="requirements/:id" element={<VenueRequirementDetailPage />} />
      </Route>

      {/* Standalone dashboards — no main Layout */}
      <Route path="/form-dashboard/:formId" element={<ProtectedRoute><FormDashboardPage /></ProtectedRoute>} />
      <Route path="/career-advisor-dashboard/:formId" element={<ProtectedRoute><CareerAdvisorDashboard /></ProtectedRoute>} />
      <Route path="/management-audit-dashboard/:formId" element={<ProtectedRoute><ManagementAuditDashboard /></ProtectedRoute>} />
      <Route path="/target-plan-dashboard/:formId" element={<ProtectedRoute roles={['admin', 'manager', 'sales_rep', 'viewer']}><TargetPlanDashboard /></ProtectedRoute>} />
      <Route path="/incentive-dashboard" element={<ProtectedRoute roles={['admin', 'manager', 'sales_rep', 'viewer']}><IncentivePayoutDashboard /></ProtectedRoute>} />

      {/* Main Layout — admin, manager, sales_rep, viewer */}
      <Route path="/" element={<ProtectedRoute roles={['admin', 'manager', 'sales_rep', 'viewer', 'course_qa']}><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<ProtectedRoute roles={['admin', 'manager', 'sales_rep', 'viewer']}><DashboardPage /></ProtectedRoute>} />
        <Route path="submissions" element={<ProtectedRoute roles={['admin', 'manager', 'sales_rep', 'viewer']}><SubmissionsPage /></ProtectedRoute>} />
        <Route path="submissions/:id" element={<ProtectedRoute roles={['admin', 'manager', 'sales_rep', 'viewer']}><SubmissionDetailPage /></ProtectedRoute>} />
        <Route path="webhooks" element={<ProtectedRoute roles={['admin', 'manager']}><WebhookConfigPage /></ProtectedRoute>} />
        <Route path="webhooks/:formId/mapping" element={<ProtectedRoute roles={['admin']}><FieldMappingPage /></ProtectedRoute>} />
        <Route path="users" element={<ProtectedRoute roles={['admin', 'manager']}><UsersPage /></ProtectedRoute>} />
        <Route path="activity" element={<ProtectedRoute roles={['admin', 'manager']}><ActivityTimelinePage /></ProtectedRoute>} />
        <Route path="whats-new" element={<ProtectedRoute roles={['admin', 'manager', 'sales_rep', 'viewer']}><WhatsNewPage /></ProtectedRoute>} />
        <Route path="zoho-reports" element={<ProtectedRoute roles={['admin', 'manager']}><ZohoReportsHub /></ProtectedRoute>} />
        <Route path="zoho-integration-map" element={<ProtectedRoute roles={['admin', 'manager']}><ZohoIntegrationMap /></ProtectedRoute>} />
        <Route path="books-analytics" element={<ProtectedRoute roles={['admin', 'manager']}><BooksAnalyticsPage /></ProtectedRoute>} />
        <Route path="books-analytics/revenue-report" element={<ProtectedRoute roles={['admin', 'manager']}><RevenueReportPage /></ProtectedRoute>} />
        <Route path="books-analytics/credit-notes" element={<ProtectedRoute roles={['admin', 'manager']}><BooksCreditNotesPage /></ProtectedRoute>} />
        <Route path="inside-sales-audit" element={<ProtectedRoute roles={['admin', 'manager']}><InsideSalesAuditPage /></ProtectedRoute>} />
        <Route path="hot-lead-transfer" element={<ProtectedRoute roles={['admin', 'manager']}><HotTransferPage /></ProtectedRoute>} />
        <Route path="callback-tracker" element={<ProtectedRoute roles={['admin', 'manager']}><CallbackTrackerPage /></ProtectedRoute>} />
        <Route path="books-analytics/sales-conversion" element={<ProtectedRoute roles={['admin', 'manager']}><SalesConversionPage /></ProtectedRoute>} />
        <Route path="books-analytics/slip-tracker-audit" element={<ProtectedRoute roles={['admin', 'manager']}><SlipTrackerAuditPage /></ProtectedRoute>} />
        <Route path="course-qa" element={<ProtectedRoute roles={['admin', 'manager', 'course_qa']}><CourseQaPage /></ProtectedRoute>} />
        <Route path="course-qa/management" element={<ProtectedRoute roles={['admin', 'manager']}><CourseQaManagementPage /></ProtectedRoute>} />
        <Route path="course-qa/all" element={<ProtectedRoute roles={['admin', 'manager', 'course_qa']}><CourseQaAllPage /></ProtectedRoute>} />
        <Route path="course-qa/defects" element={<ProtectedRoute roles={['admin', 'manager', 'course_qa']}><CourseQaDefectsPage /></ProtectedRoute>} />
        <Route path="course-qa/rules" element={<ProtectedRoute roles={['admin', 'manager', 'course_qa']}><CourseQaRulesPage /></ProtectedRoute>} />
        <Route path="cash-register" element={<ProtectedRoute roles={['admin', 'manager']}><CashRegisterPage /></ProtectedRoute>} />
        <Route path="reports" element={<ProtectedRoute roles={['admin', 'manager']}><ReportsLandingPage /></ProtectedRoute>} />
        <Route path="reports/incentive" element={<ProtectedRoute roles={['admin', 'manager']}><IncentiveReportPage /></ProtectedRoute>} />
        <Route path="reports/sales-uploads" element={<ProtectedRoute roles={['admin', 'manager']}><SalesUploadsPage /></ProtectedRoute>} />
        <Route path="settings" element={<ProtectedRoute roles={['admin']}><SettingsPage /></ProtectedRoute>} />
        <Route path="weekly-plan" element={<WeeklyPlanPage />} />
        <Route path="weekly-plan-preview" element={<WeeklyPlanPage />} />
      </Route>

      {/* Training Management Layout — admin, manager, restricted_user */}
      <Route path="/training" element={<ProtectedRoute roles={['admin', 'manager', 'restricted_user', 'training_manager', 'counsellor']}><TrainingLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/training/dashboard" replace />} />
        <Route path="trainer-demo" element={<ProtectedRoute roles={['admin', 'manager', 'counsellor']}><DemoQueuePage /></ProtectedRoute>} />
        <Route path="trainer-demo/new" element={<ProtectedRoute roles={['admin', 'manager', 'counsellor']}><NewDemoPage /></ProtectedRoute>} />
        <Route path="trainer-demo/analytics" element={<ProtectedRoute roles={['admin', 'manager', 'training_manager', 'counsellor']}><DemoAnalyticsPage /></ProtectedRoute>} />
        <Route path="trainer-demo/incentive" element={<ProtectedRoute roles={['admin', 'manager', 'training_manager']}><DemoIncentivePage /></ProtectedRoute>} />
        <Route path="trainer-demo/report" element={<Navigate to="/training/trainer-demo/analytics" replace />} />
        <Route path="trainer-demo/conversions" element={<Navigate to="/training/trainer-demo/analytics?view=admissions" replace />} />
        <Route path="trainer-demo/admission-revenue" element={<Navigate to="/training/trainer-demo/analytics?view=trainer" replace />} />
        <Route path="trainer-demo/counsellor-load" element={<Navigate to="/training/trainer-demo/analytics?view=counsellor" replace />} />
        <Route path="trainer-demo/setup" element={<ProtectedRoute roles={['admin']}><DemoSetupPage /></ProtectedRoute>} />
        <Route path="trainer-demo/d/:demoId" element={<ProtectedRoute roles={['admin', 'manager', 'counsellor']}><DemoDetailPage /></ProtectedRoute>} />
        <Route path="dashboard" element={<TrainingDashboardPage />} />
        <Route path="masters" element={<MastersPage />} />
        <Route path="batches" element={<BatchManagementPage />} />
        <Route path="students" element={<StudentsPage />} />
        <Route path="placement" element={<PlacementPage /> } />
        <Route path="slot-finder" element={<SlotFinderPage />} />
        <Route path="trainer-overview" element={<TrainerOverviewPage />} />
        <Route path="trainer-overview-v2" element={<TrainerOverviewV2Page />} />
        <Route path="trainer-scorecard" element={<TrainerScorecardPage />} />
        <Route path="new-scorecard" element={<NewTrainerScorecardPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="overdue-report" element={<OverdueReportPage filterType="overdue" />} />
        <Route path="partially-paid-report" element={<OverdueReportPage filterType="partially_paid" />} />
        <Route path="feature-requests" element={<FeatureRequestsPage />} />
        <Route path="anomalies" element={<AnomaliesPage />} />
        <Route path="tickets" element={<TicketsPage />} />
        <Route path="tickets/performance" element={<TicketPerformancePrototype />} />
        <Route path="assistant" element={<AskBaskyFullPage />} />
        <Route path="sync-settings" element={<SyncSettingsPage />} />
        <Route path="daily-attendance" element={<AdminDailyAttendancePage />} />
        <Route path="attendance-report" element={<AttendanceReportPage />} />
        <Route path="trainer-performance" element={<TrainerPerformancePage />} />
        <Route path="menu-settings" element={<ProtectedRoute roles={['admin']}><MenuSettingsPage /></ProtectedRoute>} />
        <Route path="vouchers" element={<ProtectedRoute roles={['admin', 'manager', 'training_manager']}><VoucherPage /></ProtectedRoute>} />
        <Route path="trainer-target" element={<ProtectedRoute roles={['admin', 'manager', 'training_manager']}><TrainerTargetPage /></ProtectedRoute>} />
        <Route path="trainer-dashboard" element={<AdminTrainerDashboardPage />} />
        <Route path="pdp-mock-status" element={<PdpMockStatusPage />} />
        <Route path="trainer-lab" element={<TrainerLabPage />} />
        <Route path="trainer-audit" element={<Navigate to="/training/trainer-audit/report" replace />} />
        <Route path="trainer-audit/form" element={<ProtectedRoute roles={['admin', 'manager', 'training_manager']}><AuditFormPage /></ProtectedRoute>} />
        <Route path="trainer-audit/report" element={<ProtectedRoute roles={['admin', 'manager', 'training_manager']}><AuditReportPage /></ProtectedRoute>} />
        <Route path="trainer-audit/executive" element={<ProtectedRoute roles={['admin', 'manager', 'training_manager']}><ExecutiveReportPage /></ProtectedRoute>} />
        <Route path="trainer-audit/assignments" element={<ProtectedRoute roles={['admin', 'manager']}><ManagerAssignmentsPage /></ProtectedRoute>} />
        <Route path="dpr-compliance" element={<DprComplianceReport />} />
        <Route path="dpr-report" element={<DprReportPage isAdmin={true} />} />
        <Route path="audit-bookmarks" element={<AuditBookmarksPage />} />
        <Route path="course-syllabus" element={<CourseSyllabusPage />} />
        <Route path="document-library" element={<DocumentLibraryPage />} />
        <Route path="custom-views-prototype" element={<CustomViewsPrototype />} />
        <Route path="credit-notes" element={<CreditNotesPage />} />
        <Route path="cn-review" element={<ProtectedRoute roles={['admin', 'manager']}><CnReviewPage /></ProtectedRoute>} />
        <Route path="reconciliation" element={<ReconciliationReportPage />} />
        <Route path="mom" element={<MomListPage />} />
        <Route path="mom/new" element={<MomNewPage />} />
        <Route path="mom/report" element={<MomReportPage />} />
        <Route path="mom/:id" element={<MomDetailPage />} />
        <Route path="activity" element={<ProtectedRoute roles={['admin', 'manager']}><ActivityTimelinePage /></ProtectedRoute>} />
        <Route path="whats-new" element={<WhatsNewPage />} />
        <Route path="sales-uploads" element={<Navigate to="/reports/sales-uploads" replace />} />
      </Route>
      <Route path="/trainer/login" element={user?.role === 'trainer' ? <Navigate to="/trainer/dashboard" replace /> : <TrainerLoginPage />} />
      <Route path="/trainer" element={<TrainerProtectedRoute><TrainerLayout /></TrainerProtectedRoute>}>
        <Route index element={<Navigate to="/trainer/dashboard" replace />} />
        <Route path="dashboard" element={<TrainerDashboardPage />} />
        <Route path="batches/:batchId" element={<TrainerBatchDetailPage />} />
        <Route path="report" element={<TrainerReportPage />} />
        <Route path="daily-attendance" element={<TrainerDailyAttendancePage />} />
        <Route path="dpr-report" element={<DprReportPage isAdmin={false} />} />
        <Route path="overdue" element={<TrainerOverduePage />} />
        <Route path="credit-notes" element={<TrainerCreditNotesPage />} />
        <Route path="demos" element={<DemoQueuePage />} />
        <Route path="demos/new" element={<NewDemoPage />} />
        <Route path="demos/report" element={<DemoReportPage />} />
        <Route path="demos/conversions" element={<DemoConversionsPage />} />
        <Route path="demos/d/:demoId" element={<DemoDetailPage />} />
        <Route path="document-library" element={<DocumentLibraryPage />} />
      </Route>

      <Route path="*" element={<Navigate to={defaultPath} replace />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const id = ['emer','gent','-ba','dge'].join('');
    const s = document.createElement('style');
    s.textContent = '#' + id + '{opacity:0!important;visibility:hidden!important;pointer-events:none!important;transform:scale(0)!important;}';
    document.head.appendChild(s);
    const t = setInterval(() => { const el = document.getElementById(id); if (el) el.remove(); }, 500);
    return () => clearInterval(t);
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <WhatsNewModal />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
